// NOTE


// Interface del usuario (GUI)
import { Input, Button, Fa } from 'mdbreact';
import { ToastContainer  } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// React
import React, { Component } from 'react';

// utilitarios
import byPropKey from '../utilitarios/byPropKey'
import MensajeError from '../layout/MensajeError'
import TituloCentrado from '../layout/TituloCentrado';

const ESTADO_INICIAL = {
  correo: '',
  nombre: '',
  mensaje: '',

  tocados: { 
    nombre: false,
    correo: false,
    mensaje: false
  },

  formInvalido: false,
  formTocado: false,
};

const ValidarForm = (nombre, correo, mensaje) => {
  const errores = {formInvalido:false, nombre: [], correo: [], mensaje: []}

  if (nombre.length === 0) {
    errores.nombre.push('Digite su nombre')
    errores.formInvalido = true
  }

  if (nombre.length > 20) {
    errores.nombre.push('Nombre excede los 20 caracteres')
    errores.formInvalido = true
  }

  if (correo.length > 20) {
    errores.correo.push('Digite una dirección de correo')
    errores.formInvalido = true
  }

  if (mensaje.length === 0) {
    errores.mensaje.push('Digite el mensaje')
    errores.formInvalido = true
  }

  return (errores)
}

class Contactenos extends Component {

  constructor(props) {
    super(props)
    this.state = {...ESTADO_INICIAL}
  }; 


  enviar = (event) => {
    const {
      correo,
      nombre,
      mensaje,
    } = this.state;

    const errores = ValidarForm(correo, nombre, mensaje)

    if (errores.formInvalido) {
      event.preventDefault();
      return
    }

    event.preventDefault();

  }

  render () {
    const {
      correo,
      nombre,
      mensaje,
    } = this.state;

    const errores = ValidarForm(correo, nombre, mensaje)
  
    const mostrarErrores = (campo) => {
      const mostrar = this.state.tocados[campo]
      return errores.formInvalido ? mostrar : false
    }

    return (
      <div >
        <TituloCentrado titulo='Contáctenos'/>
        <form onSubmit={this.enviar} >
         
          <div className='row justify-content-center'>
            <div className='col-sm-8'>
              <Input
                className= {mostrarErrores(nombre) ? "border border-danger" : null}
                value={nombre}
                validate error="Incorrecto" 
                success="Correcto"
                label='Nombre'
                icon="user" 
                group type="text" 
                onChange={event => this.setState(byPropKey('nombre', event.target.value))}
                onBlur={ event => this.setState({'tocados.nombre': true} )}
              />
              <MensajeError  mError = {'aqui va algo ... todavia no se que'} />
            </div>
           </div>
          
          <div className='row justify-content-center'>
            <div className='col-sm-8'>
              <Input 
                value={correo}
                label="Correo" 
                icon="envelope" 
                group type="email" 
                onChange={event => this.setState(byPropKey('correo', event.target.value))}
                onBlur={ event => this.setState({'tocados.correo': true} )}
              />
            </div>
          </div>

          <div className='row justify-content-center'>
            <div className='col-sm-8'>
              <Input
                value={mensaje}
                label="Mensaje" 
                icon="file-text" 
                onChange={event => this.setState(byPropKey('mensaje', event.target.value))}
                onBlur={ event => this.setState({'tocados.mensaje': true} )}
                />
            </div> 
          </div>

          <div className='row justify-content-center'>
            <div className='col-sm-8'>        
              <div className="text-center">
                <Button onClick={event => this.enviar(event)} type='submit'>Enviar<Fa icon="paper-plane-o" className="ml-1"/></Button>
              </div>
            </div>
          </div>
        </form>
        <ToastContainer
          hideProgressBar={true}
          newestOnTop={true}
          autoClose={5000}
        />
      </div>

    ) // fin del return

  } // fin del render
} //fin del class

export default Contactenos


// WEBPACK FOOTER //
// ./src/paginas/Contactenos.js